import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MarketmanagerSharedModule } from '../../shared';
import { MarketmanagerAdminModule } from '../../admin/admin.module';
import {
    MarketdateCommentService,
    MarketdateCommentPopupService,
    MarketdateCommentComponent,
    MarketdateCommentDetailComponent,
    MarketdateCommentDialogComponent,
    MarketdateCommentPopupComponent,
    MarketdateCommentDeletePopupComponent,
    MarketdateCommentDeleteDialogComponent,
    marketdateCommentRoute,
    marketdateCommentPopupRoute,
} from './';

const ENTITY_STATES = [
    ...marketdateCommentRoute,
    ...marketdateCommentPopupRoute,
];

@NgModule({
    imports: [
        MarketmanagerSharedModule,
        MarketmanagerAdminModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        MarketdateCommentComponent,
        MarketdateCommentDetailComponent,
        MarketdateCommentDialogComponent,
        MarketdateCommentDeleteDialogComponent,
        MarketdateCommentPopupComponent,
        MarketdateCommentDeletePopupComponent,
    ],
    entryComponents: [
        MarketdateCommentComponent,
        MarketdateCommentDialogComponent,
        MarketdateCommentPopupComponent,
        MarketdateCommentDeleteDialogComponent,
        MarketdateCommentDeletePopupComponent,
    ],
    providers: [
        MarketdateCommentService,
        MarketdateCommentPopupService,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MarketmanagerMarketdateCommentModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate-comment/marketdate-comment.module.ts